import { NgModule } from '@angular/core';
import * as fromServices from './services';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [...fromServices.services, provideHttpClient(withInterceptorsFromDi())] })

export class CoreModule { }
